export class SimulatorXRHand {}
